import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import $ from 'jquery'
import { getWebsiteContent } from './components/fetchJSON'

//import {getFromDrupalAPI} from './components/fetchJSON.js'

//Components
import FrontPageNavigation from './components/frontpage/FrontPageNavigation.js';
import FrontPageWrapper from './components/frontpage/FrontPageWrapper.js';
import OtherPageWrapper from './components/OtherPageWrapper.js';
import OtherPageNavigation from './components/OtherPageNavigation.js'
import Footer from './components/Footer.js';
import SiteNotification from './components/SiteNotification'

//Core CSS from Apropos
import './assets/plugins/bootstrap/css/bootstrap.min.css';
import './assets/css/font-awesome.css';
import './assets/css/animate.css';
import './assets/css/superslides.css';

//Theme CSS from Apropos
import './assets/css/essentials.css';
import './assets/css/layout.css';
import './assets/css/layout-responsive.css';
import './assets/css/color_scheme/darkblue.css';

//Custom CSS
import './assets/css/custom.css';
import './assets/css/notification.css';
import './assets/css/frontpageheader.css';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = { showNotification: null, html: null, loading: true }
  }

  componentWillMount() {
    var that = this;

    getWebsiteContent('SiteWideNotification', function (data) {
      that.setState({ html: data[0].html, showNotification: data[0].active, loading: false });
    });
  }


  onNotificationClose = () => {
    this.setState({ showNotification: false });
  };
  render() {
    return (
      <Router>
        <div className="App">
          <Route exact path="/" component={FrontPageNavigation} />
          <Route path="/:path" component={OtherPageNavigation} />
          <Route exact path="/" component={FrontPageWrapper} />
          <Route path="/:path" component={OtherPageWrapper} />
          <Route exact path="/" component={Footer} />
          <Route path="/:path" component={Footer} />
          {this.state.loading ? '' : <Route
            path="/"
            component={() => <SiteNotification
              showNotification={this.state.showNotification != "false"} //eslint-disable-line
              onClose={this.onNotificationClose}
              html={this.state.html ? this.state.html : ''}
            />}
          />}
        </div>
      </Router>
    );
  }

  componentDidMount() {

    //Script hack to get everything working properly
    $(function () {
      var scriptsDiv = '<script type="text/javascript">'
      scriptsDiv += 'var	$googlemap_latitude 	= -42.978481;'
      scriptsDiv += 'var $googlemap_longitude	= 147.305762;'
      scriptsDiv += 'var $googlemap_zoom			= 15;';
      scriptsDiv += '</script>';
      scriptsDiv += '<script type="text/javascript" src="./plugins/jquery-2.2.3.min.js"></script>';
      scriptsDiv += '<script type="text/javascript" src="./plugins/jquery.easing.1.3.js"></script>';
      scriptsDiv += '<script type="text/javascript" src="./plugins/bootstrap.min.js"></script>';
      scriptsDiv += '<script type="text/javascript" src="./plugins/jquery.superslides.min.js"></script>';

      scriptsDiv += '<script type="text/javascript" src="./scripts.js"></script>';

      //Home Page One Page Navigation
      scriptsDiv += '<script type="text/javascript" src="./plugins/jquery.nav.min.js"></script>';

      scriptsDiv += `<script type="text/javascript">
                    $("#topMain").onePageNav({
                    currentClass: "active",
                    changeHash: false,
                    scrollSpeed: 1000,
                    scrollThreshold: 0.1,
                    filter: ":not(.external)",
                    easing: "easeInOutExpo"});
                    </script>`;

      $("#scripts").append(scriptsDiv);
    });
  }
}

export default App;
